import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as actions from './redux/actions';
import UserTable from "./UserTable";

export class Statistics extends Component {
    static propTypes = {
        customers: PropTypes.array.isRequired,
        actions: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {filter: ''};
    }

    filter = (e) => {
        this.setState({filter: e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1)});
    };

    render() {
        const {customers, match: {params: {name}}} = this.props;
        return (
            <div className="products-statistics content-animate">
                <div className="row">
                    <form>
                        <div className="form-group">
                            <input autoFocus type="text" className="form-control" placeholder="Filter..." onChange={this.filter} />
                        </div>
                    </form>
                </div>
                <div className="row">
                    <UserTable customers={customers} nameFilter={this.state.filter} productId={name} />
                </div>
            </div>
        );
    }
}

/* istanbul ignore next */
function mapStateToProps(state) {
    return {
        customers: state.home.customers,
        productCount: state.home.products.length,
        statistics: state.home.statistics,
        relevantProducts: state.home.products,
        home: state.home,
    };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({...actions}, dispatch)
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Statistics);



// WEBPACK FOOTER //
// ./src/features/products/Statistics.js